import React from 'react';
import styles from './tooltip.module.css';

const Tooltip = ({children,title,open,onClick,onClose, onHover=false,placement, ...props}) => {

    return (
        <div className={`${styles.Tooltip}
        ${open ? styles.open :""} ${onHover ? styles.hover : ""}`}
        onClick={onClick}
        {...props}>
            {children}
            <span className={styles.tooltipContent} onClick={onClose} {...props}>
                {title}
            </span>
        </div>
    )
}

export default Tooltip;